<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.confirmation.title' | translate }}</h4>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        (click)="onNoClick()"
      ></button>
    </div>
    <div class="modal-body">
      {{ data }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="onNoClick()">
        {{ 'shared.confirmation.cancelButton' | translate }}
      </button>
      <button type="button" class="btn btn-primary" [mat-dialog-close]="true">
        {{ 'shared.confirmation.confirmButton' | translate }}
      </button>
    </div>
  </div>
</div>
